/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li2_TextInputs */

const tr_onbilgi_s10_li2_text = /** @type {(inputs: Onbilgi_S10_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API anahtarları ve diğer hassas alanlar AES-256-GCM algoritması ile şifrelenmiş olarak veritabanında saklanır. Şifre çözme anahtarı Cloudflare Secrets Store üzerinde tutulur.`)
};

const en_onbilgi_s10_li2_text = /** @type {(inputs: Onbilgi_S10_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace API keys and other sensitive fields are stored in the database encrypted with the AES-256-GCM algorithm. The decryption key is kept in the Cloudflare Secrets Store.`)
};

const de_onbilgi_s10_li2_text = /** @type {(inputs: Onbilgi_S10_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-API-Schlüssel und weitere sensible Felder werden mit dem Algorithmus AES-256-GCM verschlüsselt in der Datenbank gespeichert. Der Entschlüsselungsschlüssel wird im Cloudflare Secrets Store aufbewahrt.`)
};

const ru_onbilgi_s10_li2_text = /** @type {(inputs: Onbilgi_S10_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключи API маркетплейсов и другие чувствительные поля хранятся в базе данных в зашифрованном виде по алгоритму AES-256-GCM. Ключ расшифровки хранится в Cloudflare Secrets Store.`)
};

/**
* | output |
* | --- |
* | "Marketplace API keys and other sensitive fields are stored in the database encrypted with the AES-256-GCM algorithm. The decryption key is kept in the Cloudf..." |
*
* @param {Onbilgi_S10_Li2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li2_text = /** @type {((inputs?: Onbilgi_S10_Li2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li2_text(inputs)
	if (locale === "de") return de_onbilgi_s10_li2_text(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li2_text(inputs)
	return tr_onbilgi_s10_li2_text(inputs)
});